import React, { FC } from 'react';

import { ErrorIcon, EvIcon, EvSpinner, SuccessIcon } from '@evinced-private/ui-common';

import { isCrawlDone, isCrawlFailed } from '../../helpers/CrawlStateHelper';
import { ScanCrawlStateHelper } from '../../helpers/ScanCrawlStateHelper';
import { SCAN_STATE } from '../../interfaces/ScanState';
import { UrlSetState } from '../../interfaces/UrlSet';

interface IStatusIconProps {
	isScan: boolean;
	state?: SCAN_STATE | UrlSetState;
}

const StatusIcon: FC<IStatusIconProps> = ({ state, isScan }: IStatusIconProps) => {
	let icon;
	let iconText: string;
	const isResultsReady = isScan
		? ScanCrawlStateHelper.isScanResultsReady(state as SCAN_STATE)
		: isCrawlDone(state as UrlSetState);

	const isFailed = isScan
		? ScanCrawlStateHelper.isFailed(state as SCAN_STATE)
		: isCrawlFailed(state as UrlSetState);
	if (isResultsReady) {
		icon = SuccessIcon;
		iconText = 'Done';
	} else if (isFailed) {
		icon = ErrorIcon;
		iconText = 'Failed';
	}
	const isLoading = !isResultsReady && !isFailed;
	return (
		<div className="status">
			{isLoading ? <EvSpinner small /> : <EvIcon icon={icon} title={iconText} small />}
		</div>
	);
};

export { StatusIcon };
